import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  adjust = (event) => {
    emit('pricingSliderAdjusted', {
      bubbles: true,
      detail: {
        value: event.srcElement.value,
      },
    })
  }
}
